import { Image, Button } from "@atoms";
import { AuthSection } from "@organisms";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export interface AccountConfirmedPageTemplateProps {
  handleSignInClick: () => void;
  code: string | null;
  handleResendEmailClick: () => void;
  isLoading: boolean;
}

export const AccountConfirmedPageTemplate = ({
  handleSignInClick,
  code,
  handleResendEmailClick,
  isLoading,
}: AccountConfirmedPageTemplateProps): JSX.Element => {
  const { t } = useTranslation();
  
  // Determine the content based on whether a code parameter exists
  const getContent = () => {
    if (code == "success") {
      return {
        title: t("auth.accountConfirmed.successTitle"),
        description: t("auth.accountConfirmed.successDescription"),
        buttonText: t("auth.common.signInCta"),
        buttonClickFunction: handleSignInClick,
      };
    } else if(code == "expiredCode") {
      return {
        title: t("auth.accountConfirmed.expiredTitle"),
        description: t("auth.accountConfirmed.expiredDescription"),
        buttonText: t("auth.accountConfirmed.requestNew"),
        buttonClickFunction: handleResendEmailClick,
      };
    } else if(code == "invalidCode") {
      return {
        title: t("auth.accountConfirmed.invalidTitle"),
        description: t("auth.accountConfirmed.invalidDescription"),
        buttonText: t("auth.accountConfirmed.requestNew"),
        buttonClickFunction: handleResendEmailClick,
      };
    } else if(code == "error") {
      return {
        title: t("auth.accountConfirmed.alreadyTitle"),
        description: t("auth.accountConfirmed.alreadyDescription"),
        buttonText: t("auth.common.backToSignIn"),
        buttonClickFunction: handleSignInClick,
      };
    }
  };

  const content = getContent();

  return (
    <div className="min-h-screen flex">
      <AuthSection />

      {/* Right side - Confirmation message */}
      <div className="w-full lg:w-1/2 min-h-screen flex items-center justify-center bg-white">
        <div className="w-full max-w-md px-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {content?.title}
          </h1>
          <p className="text-lg text-gray-700 mb-8">
            {content?.description}
          </p>
          <Button
            variant="primary"
            label={content?.buttonText || t("auth.common.signInCta")}
            stretch
            color="primary-medium" 
            // hoverColor="neutral-dark"
            textColor="white"
            onClick={content?.buttonClickFunction}
            loading={isLoading}
          />
          {/* <Button
            variant="primary"
            label="Go back to Sign In"
            stretch
            color="white"
            hoverColor="neutral-dark"
            textColor="black"
            onClick={handleSignInClick}
          /> */}
        </div>
      </div>
    </div>
  );
};
